// extracted by mini-css-extract-plugin
export default {"root":"ApprovedTableHeader_root__LAxkN","heading":"ApprovedTableHeader_heading__coEdw"};